import { toast as _toast } from "react-hot-toast";

const toast = {
    success: (message: string) => {
        _toast.success(message, {
            style: {
                background: "#1E1E1E",
                color: "#fff",
            },
        });
    },
    error: (message: string) => {
        _toast.error(message, {
            style: {
                background: "#1E1E1E",
                color: "#fff",
            },
        });
    },
    info: (message: string) => {
        _toast(message, {
            icon: "ℹ️",
            iconTheme: {
                primary: "#1E1E1E",
                secondary: "#fff",
            },
        });
    },
};

export default toast;
